export default __webpack_public_path__ + "imgs/6e48c6f8760221c889807bebbd1aac90.png";